// Archivo para crear los botones de manera dinámica dependiendo el módulo
import React, { useState } from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import { Add, Download } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import GenericModal from "../modal/GenericModal";
import { useCrud } from "../../context/CrudContext"; // Correcta importación
import {
    exportCSV,
    exportExcel,
    exportPDF,
    exportImage,
} from "../../utils/ExportData.js";

const ActionButtons = () => {
    const location = useLocation();
    const { handleCrudOperation, loadingStates } = useCrud(); // Hook movido arriba

    const moduleNames = {
        "/users": "Usuario",
        "/clients": "Cliente",
        "/products": "Producto",
        "/activities": "Actividad",
    };

    const genderedModuleNames = {
        Actividad: "Nueva",
        Cliente: "Nuevo",
        Usuario: "Nuevo",
        Producto: "Nuevo",
    };

    // Definir Hooks antes de cualquier return
    const currentModule = moduleNames[location.pathname];
    const genderPrefix = genderedModuleNames[currentModule] || "Nuevo";
    const [openCreate, setOpenCreate] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    // Bloquear creación de actividades en /activities
    if (currentModule === "Actividad") return null;

    const handleExport = (type) => {
        const sampleData = [
            ["ID", "Nombre", "Fecha"],
            [1, "Ejemplo 1", "2024-03-04"],
            [2, "Ejemplo 2", "2024-03-04"],
        ];

        switch (type) {
            case "csv":
                exportCSV(sampleData);
                break;
            case "excel":
                exportExcel(sampleData);
                break;
            case "pdf":
                exportPDF(sampleData);
                break;
            case "image":
                exportImage("data-table");
                break;
            default:
                break;
        }

        setAnchorEl(null);
    };

    // Crear actividad con `useCrud`
    const handleCreate = async (formData) => {
        try {
            await handleCrudOperation(formData);
            setOpenCreate(false);
        } catch (error) {
            console.error("Error al crear la actividad:", error);
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "end", mb: 2 }}>
            {/* Botón de Exportación con menú */}
            <Button
                variant="text"
                startIcon={<Download />}
                sx={{ mr: 2 }}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                Exportar
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleExport("csv")}>CSV</MenuItem>
                <MenuItem onClick={() => handleExport("excel")}>Excel</MenuItem>
                <MenuItem onClick={() => handleExport("pdf")}>PDF</MenuItem>
                <MenuItem onClick={() => handleExport("image")}>Imagen</MenuItem>
            </Menu>

            {/* Botón de Crear */}
            <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={() => setOpenCreate(true)}
            >
                {`${genderPrefix} ${currentModule}`}
            </Button>

            {/* Modal de Creación */}
            <GenericModal
                open={openCreate}
                onClose={() => setOpenCreate(false)}
                onConfirm={handleCreate}
                title={`${genderPrefix} ${currentModule}`}
                confirmText={loadingStates.create ? "Creando..." : "Crear"}
                cancelText="Cancelar"
                module={currentModule}
            />
        </Box>
    );
};

export default ActionButtons;
